<template>
  <main class="curriculum">
    <!-- 课程列表 -->
    <section class="list" v-for="(item,index) in courseList" :key="index">
      <div class="list-class">
        <div class="left">
          <img class="img" :src="item.courseCoverUrl" alt="课程背景" :onerror="errorImg" />
          <i :class="{'course-type-icon':true,'compulsory':item.courseType === 1,'elective-course':item.courseType === 2,'free':item.courseType === 3}"></i>
          <div>
            <p class="title" title="课程名称">{{item.courseName}}</p>
            <p class="detail" v-if="item.chapterCount==0 && item.lessonCount==0">内容更新中</p>
            <p class="detail" v-else><span v-if="item.chapterCount!=0">共{{item.chapterCount}}章</span><span v-if="item.chapterCount!=0 && item.lessonCount != 0"> · </span><span v-if="item.lessonCount!=0">共{{item.lessonCount}}课次</span></p>
          </div>
        </div>
        <div class="right">
          <i :class="{'open':item.isVisible,'merge':!item.isVisible}" @click="toggleClass(item,index)"></i>
        </div>
      </div>
      <!-- 章节列表 -->
      <div class="class-content">
        <el-collapse-transition>
          <ul class="curriculumList" v-if="item.isVisible">
            <li v-for="(list,listIndex) in item.childrenList" :key="listIndex">
              <div v-if="list.type === 1">
                <div class="chapter">
                  <div class="chapter-title">
                    <em class="chapter-index">{{listIndex+1<10?'0'+(listIndex+1):listIndex}}</em>
                    <span>{{list.name}}</span>
                  </div>
                  <div v-if="list.childrenList.length>0" class="toggle-icon">
                    <i :class="{'chapterMerge':list.isChapterVisible,'chapterOpen':!list.isChapterVisible}" @click="toggleLesson(list)"></i>
                  </div>
                </div>
                <!-- 课次列表 -->
                <el-collapse-transition>
                  <ul v-if="!list.isChapterVisible">
                    <li class="class" v-for="(lesson,lessonIndex) in list.childrenList" :key="lessonIndex">
                      <div class="content" @click="learningLesson(lesson,list.id,item.courseId,item.courseType)">
                        <div class="left">
                          <img class="videoAudio-icon" v-if="lesson.lessonAudioVideo && !lesson.playing && lesson.lessonAudioVideo.type === 1" :src="lesson.isFinish===1?audioEdIcon:audioIcon" alt="音频">
                          <img class="videoAudio-icon" v-if="lesson.lessonAudioVideo && !lesson.playing && lesson.lessonAudioVideo.type === 2" :src="lesson.isFinish===1?videoEdIcon:videoIcon" alt="视频">
                          <img v-if="lesson.playing" class="current-play-icon" src="@/assets/image/audio-playgif.gif" alt="正在播放">
                          <div v-if="!lesson.lessonAudioVideo && !lesson.playing" class="empty-box"></div>
                          <span :class="{'class-name':true,'active':lesson.playing,'played':lesson.isFinish===1}">{{lesson.name}}</span>
                        </div>
                        <div class="right">
                          <span v-show="lesson.playing" class="learning">正在学习</span><span v-if="lesson.lessonAudioVideo" class="time-long">{{$formatFileLength(lesson.lessonAudioVideo.length)}}</span>
                          <div class="finish-state">
                            <i :class="iconClass(lesson)"></i>
                          </div>
                        </div>
                      </div>
                      <div class="exercises" v-if="lesson.lessonQuestionList.length>0" @click="goTodoProblem(1,item.courseId, item.courseName, lesson.id, lesson.name,item)">
                        <img :src="exercisesIcon" alt="练习题">
                        <span>课后练习</span>
                      </div>
                    </li>
                  </ul>
                </el-collapse-transition>
                <!-- 课次列表end -->
              </div>
              <ul class="class chapter-class" v-if="list.type === 4">
                <li class="content" @click="learningLesson(list,list.id,item.courseId,item.courseType)">
                  <div class="left">
                    <img class="videoAudio-icon" v-if="list.lessonAudioVideo && !list.playing && list.lessonAudioVideo.type === 1" :src="list.isFinish===1?audioEdIcon:audioIcon" alt="音频">
                    <img class="videoAudio-icon" v-if="list.lessonAudioVideo && !list.playing && list.lessonAudioVideo.type === 2" :src="list.isFinish===1?videoEdIcon:videoIcon" alt="视频">
                    <img v-if="list.playing" class="current-play-icon" src="@/assets/image/videoPlaying2.png" alt="正在播放">
                    <div v-if="!list.lessonAudioVideo && !list.playing" class="empty-box"></div>
                    <span :class="{'class-name':true,'active':list.playing,'played':list.isFinish===1}">{{list.name}}</span>
                  </div>
                  <div class="right">
                    <span v-show="list.playing" class="learning">正在学习</span><span v-if="list.lessonAudioVideo" class="time-long">{{$formatFileLength(list.lessonAudioVideo.length)}}</span>
                    <div class="finish-state">
                      <i :class="iconClass(list)"></i>
                    </div>
                  </div>
                </li>
                <div class="exercises chapter-class-exercises" v-if="list.lessonQuestionList.length>0" @click="goTodoProblem(1,item.courseId, item.courseName, list.id, list.name)">
                  <img :src="exercisesIcon" alt="练习题">
                  <span>课后练习</span>
                </div>
              </ul>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </section>
    <ConfirmDialog :isShowConfirm="toThreeLearnDialog" :isOneBtn="true" :content="thirdPartyText" @handleClose="handleClose" @handleConfirm="handleClose"></ConfirmDialog>
  </main>
</template>

<script>
import { courseStore } from "@/store/course.js";
export default {
  name: "CourseCurriculum",
  props: {
    // 课程列表
    courseList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 三方开课相关
    thirdPartyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      // 资源图标
      videoIcon: require('@/assets/image/video.png'),
      audioIcon: require('@/assets/image/audio.png'),
      exercisesIcon: require('@/assets/image/exercises.png'),
      // 资源播放完成图标
      videoEdIcon: require('@/assets/image/video-finish.png'),
      audioEdIcon: require('@/assets/image/audio-finish.png'),
      // 课程默认占位图
      errorImg: 'this.src="' + require('@/assets/image/course-bg.png') + '"',
      // 课程商店
      store: courseStore(),
      // 项目id
      projectId: '',
      // 订单id
      orderId: '',
      // 最近学习的课次id
      newestLessonId: '',
      // 最近学习的课次历史时长
      duration: null,
      // 三方开课提示弹窗
      toThreeLearnDialog: false,
      // 三方平台名称
      thirdPartyText: '',
      // 定时器
      timer: null
    }
  },
  created() {
    const params = this.$route.params
    const query = this.$route.query
    this.projectId = params.id
    this.orderId = query.orderId


    // 获取学习记录
    this.newestLearning()
  },
  methods: {
    // 展开收起
    async toggleClass(item, index) {
      // 首次展开需要填充课程目录
      if (item.childrenList.length === 0) {
        const classList = await this.getClassList(item.courseId)
        item.childrenList = classList
      }
      item.isVisible = !item.isVisible
      this.$set(this.courseList, index, item)
    },

    // 获取课程目录
    getClassList(id) {
      return this.$axios.$get('/learning/user/project/pc/catalog/v1', {
        params: {
          projectId: this.projectId,
          courseId: id
        }
      })
    },

    // 章节展开收起
    toggleLesson(list) {
      const isChapterVisible = !list.isChapterVisible
      this.$set(list, 'isChapterVisible', isChapterVisible)
      this.$forceUpdate() // 强制重绘
    },

    // 目录图标
    iconClass(list) {
      if (list.playing) {
        return 'inProgress'
      } else {
        if (list.isFinish === 1) {
          return 'accomplish'
        } else {
          if (list.lessonAudioVideo) {
            if (list.lessonAudioVideo?.duration && list.lessonAudioVideo.duration > 0) {
              return 'inProgress'
            } else {
              return 'unfinished'
            }
          }
        }
      }
    },

    // 查看最近学习记录
    async newestLearning() {
      try {
        const data = await this.$axios.$get('/learning/user/lesson/record/pc/newest/v1', {
          params: {
            projectId: this.$route.params.id
          }
        })
        // 如有最近学习记录
        if (data) {
          // 课程id
          const newestCourseId = data.courseId
          // 课次id
          const newestLessonId = data.courseCatalogId
          // 最近学习的课次id
          this.newestLessonId = newestLessonId
          // 最近学习课次的历史时长
          this.duration = data.duration

          // 填充子集并展开该课程
          this.setChildren(newestCourseId, newestLessonId)
        } else {
          // 默认展开首个课程
          this.setChildren(this.courseList[0].courseId, '')
        }
      } catch (err) {
        // 无记录时隐藏继续学习按钮
      }
    },

    // 拿到该课程下的目录并展开
    async setChildren(courseId, lessonId) {

      const classList = await this.getClassList(courseId)

      this.courseList.forEach((item, index) => {
        if (item.courseId === courseId) {
          item.childrenList = classList
          item.isVisible = true
          this.$set(this.courseList, index, item)

          // 定位当前课次  
          // TODO: 这里没有章节id，只有课程和课次id，所以需要一章一章去遍历匹配
          item.childrenList.forEach(list => {
            // 如果是章，并且章下有课次
            if (list.type === 1 && list.childrenList) {
              // 向下匹配
              list.childrenList.forEach(lesson => {
                if (lesson.id === lessonId) {
                  // 只标记当前课次，不执行
                  this.playHandle(courseId, list.id, lesson, 'doNot')
                  // 通知父级有最近学习
                  this.$emit('haveNewestInfo')
                  return
                }
              })
              // 如果是课次，则直接匹配
            } else if (list.type === 4) {
              if (list.id === lessonId) {
                // 只标记当前课次，不执行
                this.playHandle(courseId, list.id, list, 'doNot')
                // 通知父级有最近学习
                this.$emit('haveNewestInfo')
                return
              }
            }
          })
        }
      })

    },

    // 点击课次-去学习
    learningLesson(lessonInfo, chapterId, courseId, courseType) {

      // 是三方开课的课程时
      if (this.thirdPartyInfo.thirdParty === 1) {
        if (this.thirdPartyInfo?.startStatus === 1) {
          if (courseType === 1) {
            this.toThreeLearnDialog = true
            let thirdPartyName = '云朵'
            if (this.thirdPartyInfo?.thirdPartyPlatform === 1) thirdPartyName = '小鹅通'
            this.thirdPartyText = `课程学习视频暂时无法观看，请前往${thirdPartyName}观看，给您造成的不便敬请谅解`
            return
          }
        } else {
          this.toThreeLearnDialog = true
          this.thirdPartyText = `暂未开课`
          return
        }
      }

      // 立即执行
      this.playHandle(courseId, chapterId, lessonInfo, 'immediately')
    },

    // 根据当前目录创造【音频】播放列表，并顺序播放（播放完毕事件由父组件抛出）
    async createdPlayList(courseId, endLessonId) {

      // TODO: 因没有从头播放的入口，目前播放入口只有两个（1，点击课次学习时  2，点击继续学习时）
      //       故，只有当前存在【当前课次id】或【最近学习的课次id】时，才会创造此列表

      const classList = await this.getClassList(courseId)
      let arr = []
      if (classList.length > 0) {
        classList.forEach(list => {
          if (list.type === 1) {
            if (list.childrenList) {
              list.childrenList.forEach(item => {
                arr.push({
                  chapterId: list.id,
                  id: item.id,
                  name: item.name,
                  lessonAudioVideo: item.lessonAudioVideo
                })
              })
            }
          } else if (list.type === 4) {
            arr.push({
              chapterId: list.id,
              id: list.id,
              name: list.name,
              lessonAudioVideo: list.lessonAudioVideo
            })
          }
        })
      }

      // 匹配到当前播放的，去播放下一个
      if (arr.length > 0 && endLessonId) {
        arr.forEach((p, i) => {
          if (p.id === endLessonId) {
            if (i !== arr.length - 1) {
              if (arr[i + 1].lessonAudioVideo) {
                if (arr[i + 1].lessonAudioVideo.type === 1 && arr[i + 1].lessonAudioVideo.url != '') {
                  this.playHandle(courseId, arr[i + 1].chapterId, arr[i + 1], 'immediately')
                } else {
                  // 为视频时->给与提示
                  this.$message.error('暂无可播放的音频资源')
                  this.playHandle(courseId, arr[i + 1].chapterId, arr[i + 1], 'doNot')
                  this.timer = setTimeout(() => {
                    // 递归向下找
                    this.createdPlayList(courseId, arr[i + 1].id)
                  }, 3000);
                }
              } else {
                this.playHandle(courseId, arr[i + 1].chapterId, arr[i + 1], 'doNot')
                // 递归向下找
                this.timer = setTimeout(() => {
                  this.createdPlayList(courseId, arr[i + 1].id)
                }, 3000);
              }
            } else {
              console.log('已播放完所有音频，请返回目录选择其他课程')
            }
          }
        })
      }
    },

    // 播放
    playHandle(courseId, chapterId, lessonInfo, type) {

      // 如有自动播放队列在执行，则阻止
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      const lessonId = lessonInfo.id
      const lessonName = lessonInfo.name
      const lessonAudioVideo = lessonInfo.lessonAudioVideo

      // 存储播放所需的相关id
      const courseInfo = {
        projectId: this.projectId,
        orderId: this.orderId,
        newestLessonId: this.newestLessonId,
        duration: this.duration,
        courseId,
        chapterId,
        lessonId: lessonId,
        lessonName: lessonName,
        lessonAudioVideo: lessonAudioVideo
      }
      this.store.setCourseInfo(courseInfo)
      localStorage.setItem('courseInfo', JSON.stringify(courseInfo))

      if (lessonAudioVideo) {
        // 是否立即执行
        if (type === 'immediately') {
          if (lessonAudioVideo.type === 1) { // 音频
            // 通知父组件去播放音频
            this.$emit('learningLesson')
          } else if (lessonAudioVideo.type === 2) { // 视频  
            this.$router.push({ path: '/course/videos', query: { projectId: this.projectId, courseId, lessonId: lessonInfo.id } })
          }
        }
      } else {
        this.$message.error('暂无可播放资源')
        // TODO: 这里的 [return] 会阻断渲染当前选中状态，（在无资源的课次点击播放时，不做高亮显示）
        // return
      }

      // 筛选选中课程，标记播放状态
      let temp = this.clearPlayStatus(this.courseList)

      // (严格目录层级时可取)
      // temp.find(list => list.courseId === courseId).childrenList
      //   .find(chapter => chapter.id === chapterId).childrenList
      //   .find(lesson => lesson.id === lessonId).playing = true

      // 课次层级不固定时可取
      temp.forEach(list => {
        if (list.courseId === courseId) {
          if (list.childrenList) {
            list.childrenList.forEach(chapter => {
              if (chapter.id === chapterId) {
                if (chapter.type === 1) {
                  chapter.childrenList.forEach(lesson => {
                    if (lesson.id === lessonId) {
                      lesson.playing = true
                    }
                  })
                } else if (chapter.type === 4) {
                  chapter.playing = true
                  return
                }
              }
            })
          }
        }
      })

      this.chapterList = [...temp]
      this.$forceUpdate()

    },

    // 重置播放状态
    clearPlayStatus(courseList) {
      courseList.forEach(list => {
        list.childrenList.forEach(item => {
          if (item.type === 4) {
            item.playing = false
          } else {
            if (item.childrenList && item.childrenList.length > 0) {
              item.childrenList.forEach(lesson => {
                lesson.playing = false
              })
            }
          }
        })
      })
      return courseList
    },

    // TODO:去做题
    goTodoProblem(type, courseId, courseName, lessonId, lessonName) {
      this.$emit('toTopic', type, courseId, courseName, lessonId, lessonName)
    },


    // 三方开课弹窗关闭
    handleClose() {
      this.toThreeLearnDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.curriculum {
  .list {
    margin: 30px 0;
    .list-class {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 89px;
      background: #f1f3f8;
      border-radius: 8px;
      position: relative;
      overflow: hidden;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .course-type-icon {
          position: absolute;
          left: 0;
          top: 0;
          display: block;
          width: 38px;
          height: 18px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &.compulsory {
            background-image: url("@/assets/image/courseType1.png");
          }
          &.elective-course {
            background-image: url("@/assets/image/courseType2.png");
          }
          &.free {
            background-image: url("@/assets/image/courseType3.png");
          }
        }
        .img {
          width: 158px;
          height: 89px;
          margin-right: 20px;
          background: #a39497;
        }
        .title {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          padding-right: 30px;
        }
        .detail {
          margin-top: 5px;
          font-size: 14px;
          color: $grey-font-color;
          line-height: 20px;
        }
      }
      .right {
        i {
          display: inline-block;
          width: 32px;
          height: 32px;
          margin-right: 30px;
          cursor: pointer;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &.open {
            background-image: url("@/assets/image/arrow_up.png");
          }
          &.merge {
            background-image: url("@/assets/image/arrow_down.png");
          }
        }
      }
    }
    .class-content {
      margin-top: 20px;
      .curriculumList {
        .chapter {
          width: 100%;
          height: 54px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #f1f3f8;
          .chapter-title {
            font-size: 14px;
            font-weight: 500;
            font-family: $font-family-PingFangMedium;
            .chapter-index {
              margin-right: 8px;
            }
            span {
              word-break: break-all;
            }
          }
          .toggle-icon {
            margin-right: 34px;
            i {
              display: inline-block;
              width: 24px;
              height: 24px;
              cursor: pointer;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              &.chapterMerge {
                background-image: url("@/assets/image/arrow_down2.png");
              }
              &.chapterOpen {
                background-image: url("@/assets/image/arrow_up2.png");
              }
            }
          }
        }
        .class {
          padding: 20px 38px 20px 0;
          margin: 0 0 0 27px;
          border-bottom: 1px solid #f1f3f8;
          .content {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            .left,
            .right {
              display: flex;
              align-items: center;
            }
            .videoAudio-icon,
            .current-play-icon,
            .empty-box {
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
            .class-name {
              font-size: 14px;
              line-height: 20px;
              max-width: 650px;
              word-break: break-all;
              &.active {
                color: $theme-color !important;
              }
              &.played {
                color: $grey-font-color;
              }
            }
            .learning {
              font-size: 12px;
              color: $theme-color;
              margin-right: 10px;
            }
            .time-long {
              font-size: 12px;
              color: $grey-font-color;
            }
            .time-long {
              margin-left: 5px;
            }
            .finish-state {
              display: flex;
              align-items: center;
              margin-left: 35px;
              i {
                display: inline-block;
                width: 16px;
                height: 16px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                &.unfinished {
                  background-image: url("@/assets/image/unfinished.png");
                }
                &.accomplish {
                  background-image: url("@/assets/image/accomplish.png");
                }
                &.inProgress {
                  background-image: url("@/assets/image/inProgress.png");
                }
              }
            }
          }
          .exercises {
            margin-top: 15px;
            margin-left: 27px;
            width: 79px;
            background: rgba(225, 63, 55, 0.05);
            border-radius: 2px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            cursor: pointer;
            img {
              width: 12px;
              height: 12px;
              margin-right: 7px;
            }
          }
        }
        .chapter-class {
          margin: 0;
          .chapter-class-exercises {
            margin-left: 0;
          }
        }
      }
    }
  }
}
</style>
